import {View }from "./View"

export const Products = () => {
    return (
        <View/>
    )
}
